import { useImperativeHandle, forwardRef } from 'react';
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import { useControl } from "react-map-gl";

// DrawControl component
const DrawControl = forwardRef((props, ref) => {
  const draw = useControl(
    // Initialize the MapboxDraw instance with the passed props
    () => new MapboxDraw(props),
    // When the control is added to the map
    ({ map, control }) => {
      // Attach event listeners for create, update, and delete actions
      map.on("draw.create", props.onCreate);
      map.on("draw.update", props.onUpdate);
      map.on("draw.delete", props.onDelete);
      map.on("draw.modechange", props.onModeChange);
      map.on("draw.selectionchange", props.onSelectionchange);
    },
    // When the control is removed from the map
    ({ map }) => {
      // Remove event listeners
      map.off("draw.create", props.onCreate);
      map.off("draw.update", props.onUpdate);
      map.off("draw.delete", props.onDelete);
      map.off("draw.delete", props.onDelete);
      map.off("draw.modechange", props.onModeChange);
      map.off("draw.selectionchange", props.onSelectionchange);
    },
    {
      position: props.position // This handles the position, default is 'top-right'
    }
  );

  // Forward the ref to the MapboxDraw instance
  useImperativeHandle(ref, () => draw);

  return null;
});

DrawControl.defaultProps = {
  onCreate: () => { },
  onUpdate: () => { },
  onDelete: () => { },
  onSelectionchange: () => { },
  onModeChange: () => { }
};

export default DrawControl;
